/**
 * Sjekker om prefers-reduced-motion er satt til "reduce" eller ikke
 * @returns true dersom klienten ønsker mindre bevegelse
 */
export const prefersReducedMotion = (): boolean => {
  const mediaQuery = window && window.matchMedia('(prefers-reduced-motion: reduce)');

  return !mediaQuery || mediaQuery.matches;
};
